{
  "days": {
    "friday": "Vendredi",
    "monday": "Lundi",
    "saturday": "Samedi",
    "sunday": "Dimanche",
    "thursday": "Jeudi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi"
  },
  "discover": {
    "explore": "Explorer les lieux"
  },
  "explore_list": {
    "description": "Cette liste est extraite de {wikipage}.",
    "error": "Une erreur est survenue lors du chargement de la liste.",
    "title": "Explorer",
    "wikipage": "la page wiki Indoor Mapping"
  },
  "heatmap": {
    "hide": "Cacher la carte de chaleur",
    "show": "Voir la carte de chaleur"
  },
  "opening_hours": {
    "state": {
      "closed": "fermé",
      "open": "ouvert"
    },
    "state_until_date": "{state} jusqu'à {date}",
    "tomorrow": "demain",
    "url": "Visiter le site pour consulter les horaires"
  },
  "poi": {
    "aerialway": {
      "station": "Station"
    },
    "aeroway": {
      "gate": "Porte d'embarquement"
    },
    "amenity": {
      "arts_centre": "Centre des arts",
      "atm": "Distributeur de billets",
      "bank": "Banque",
      "bar": "Bar",
      "bbq": "Barbecue",
      "bench": "Banc",
      "bicycle_parking": "Parking vélo",
      "bicycle_rental": "Location de vélos",
      "biergarten": "Biergarten",
      "bureau_de_change": "Bureau de change",
      "bus_station": "Station de bus",
      "cafe": "Café",
      "car_rental": "Location de voitures",
      "cinema": "Cinéma",
      "clinic": "Clinique",
      "college": "Établissement d'enseignement supérieur",
      "community_centre": "Centre communautaire",
      "courthouse": "Tribunal",
      "dentist": "Dentiste",
      "doctors": "Docteurs",
      "embassy": "Ambassade",
      "fast_food": "Restauration rapide",
      "ferry_terminal": "Terminal de ferry",
      "fire_station": "Caserne de pompiers",
      "food_court": "Aire de restauration",
      "fuel": "Station essence",
      "grave_yard": "Cimetière",
      "hospital": "Hopital",
      "ice_cream": "Glace",
      "kindergarten": "Jardin d'enfants",
      "library": "Bibliothèque",
      "marketplace": "Marché",
      "motorcycle_parking": "Parking moto",
      "nightclub": "Discothèque",
      "nursing_home": "Maison de repos",
      "parking": "Parking",
      "pharmacy": "Pharmacie",
      "photo_booth": "Cabine photo",
      "piano": "Piano",
      "place_of_worship": "Lieu de culte",
      "police": "Police",
      "post_box": "Boite aux lettres",
      "post_office": "Bureau de poste",
      "prison": "Prison",
      "pub": "Pub",
      "public_building": "Bâtiment public",
      "recycling": "Recyclage",
      "restaurant": "Restaurant",
      "school": "École",
      "shelter": "Abri",
      "swimming_pool": "Piscine",
      "taxi": "Taxi",
      "telephone": "Téléphone",
      "theatre": "Théatre",
      "ticket_validator": "Composteur de billet",
      "toilets": "Toilette",
      "townhall": "Mairie",
      "university": "Université",
      "vending_machine": "Distributeur automatique",
      "veterinary": "Vétérinaire",
      "waste_basket": "Poubelle"
    },
    "barrier": {
      "bollard": "Bollard",
      "border_control": "Border control",
      "cycle_barrier": "Cycle barrier",
      "gate": "Porte",
      "lift_gate": "Lift gate",
      "sally_port": "Sally port",
      "stile": "Stile",
      "toll_booth": "Péage"
    },
    "craft": {
      "brewery": "Brasserie",
      "caterer": "Traiteur",
      "confectionery": "Confiserie",
      "dressmaker": "Couturier",
      "electronics_repair": "Réparation électronique",
      "shoemaker": "Cordonnier",
      "tailor": "Tailleur"
    },
    "door": {
      "door": "Porte",
      "hinged": "Porte",
      "no": "Porte",
      "overhead": "Porte",
      "sliding": "Porte coulissante",
      "yes": "Porte"
    },
    "emergency": {
      "defibrillator": "Défibrillateur",
      "fire_extinguisher": "Extincteur",
      "phone": "Téléphone d'urgence"
    },
    "entrance": {
      "building": "Entrée",
      "emergency": "Sortie de secours",
      "exit": "Sortie",
      "home": "Entrée",
      "main": "Entrée",
      "service": "Service",
      "shop": "Entrée",
      "staircase": "Entrée",
      "yes": "Entrée"
    },
    "exhibit": {
      "artwork": "Œuvre d'art",
      "history": "History"
    },
    "highway": {
      "elevator": "Ascenseur"
    },
    "landuse": {
      "basin": "Bassin",
      "brownfield": "Friche industrielle",
      "cemetery": "Cimetière",
      "reservoir": "Réservoir",
      "winter_sports": "Sport d'hiver"
    },
    "leisure": {
      "dog_park": "Parc a chiens",
      "escape_game": "Escape game",
      "garden": "Jardin",
      "golf_course": "Terrain de course",
      "hackerspace": "Hackerspace",
      "ice_rink": "Patinoire",
      "marina": "Marina",
      "miniature_golf": "Mini-golf",
      "park": "Parc",
      "pitch": "Terrain",
      "playground": "Terrain de jeu",
      "sports_centre": "Centre sportif",
      "stadium": "Stade",
      "swimming_area": "Swimming area",
      "swimming_pool": "Piscine",
      "water_park": "Parc aquatique"
    },
    "office": {
      "government": "Gouvernment"
    },
    "railway": {
      "halt": "Arrêt",
      "station": "Station",
      "subway_entrance": "Entrée de métro",
      "train_station_entrance": "Train station entrance",
      "tram_stop": "Tram stop"
    },
    "shop": {
      "accessories": "Accessoires",
      "alcohol": "Alcool",
      "antiques": "Antiquités",
      "art": "Art",
      "bag": "Sacs",
      "bakery": "Boulangerie",
      "beauty": "Salon de Beauté",
      "bed": "Lit",
      "beverages": "Boissons",
      "bicycle": "Vélo",
      "books": "Librairie",
      "boutique": "Boutique",
      "butcher": "Boucherie",
      "camera": "Caméra",
      "car": "Voiture",
      "car_parts": "Pièces de voitures",
      "car_repair": "Réparation de voiture",
      "carpet": "Tapis",
      "charity": "Charité",
      "cheese": "Fromagerie",
      "chemist": "Chimiste",
      "chocolate": "Chocolaterie",
      "clothes": "Vêtement",
      "coffee": "Café",
      "computer": "Ordinateur",
      "confectionery": "Confiserie",
      "convenience": "Épicerie",
      "copyshop": "Copie",
      "cosmetics": "Cosmétique",
      "deli": "Épicerie",
      "delicatessen": "Épicerie fine",
      "department_store": "Grand magasin",
      "doityourself": "Bricolage",
      "dry_cleaning": "Nettoyage a sec",
      "electronics": "Électronique",
      "erotic": "Érotique",
      "fabric": "Tissu",
      "fashion_accessories": "Accessoires de modes",
      "florist": "Fleuriste",
      "frame": "Cadre",
      "frozen_food": "Surgelès",
      "furniture": "Meuble",
      "garden_centre": "Jardin",
      "general": "General",
      "gift": "Cadeau",
      "greengrocer": "Primeur",
      "hairdresser": "Coiffeu",
      "hardware": "Matériel",
      "hearing_aids": "Prothèses auditives",
      "hifi": "Hifi",
      "houseware": "Articles ménagers",
      "ice_cream": "Glace",
      "interior_decoration": "Décoration intérieur",
      "jewelry": "Bijoux",
      "kiosk": "Kiosque",
      "kitchen": "Cuisine",
      "lamps": "Lampes",
      "laundry": "Blanchisserie",
      "leather": "Cuir",
      "locksmith": "Serurerie",
      "mall": "Centre commercial",
      "massage": "Massage",
      "mobile_phone": "Téléphone mobile",
      "motorcycle": "Moto",
      "music": "Musique",
      "musical_instrument": "Instrument de musique",
      "newsagent": "Marchand de journaux",
      "optician": "Opticien",
      "outdoor": "Plein air",
      "pastry": "Pâtisserie",
      "perfume": "Parfumerie",
      "perfumery": "Parfumerie",
      "pet": "Animal de compagnie",
      "photo": "Photo",
      "seafood": "Poissonerie",
      "second_hand": "Occasion",
      "shoes": "Chaussures",
      "sports": "Sports",
      "stationery": "Papeterie",
      "supermarket": "Supermarché",
      "tailor": "Tailleur",
      "tattoo": "Tatoueur",
      "tea": "Thé",
      "ticket": "Ticket",
      "tobacco": "Tabac",
      "toys": "Jouets",
      "travel_agency": "Agence de voyage",
      "variety_store": "Magasin de variétés",
      "video": "Video",
      "video_games": "Jeux videos",
      "watches": "Montre",
      "weapons": "Armes",
      "wholesale": "Vente de gros",
      "wine": "Vin"
    },
    "sport": {
      "american_football": "Football américain",
      "archery": "Tir a l'arc",
      "athletics": "Athlétisme",
      "australian_football": "Australian football",
      "badminton": "Badminton",
      "baseball": "Baseball",
      "basketball": "Basketball",
      "beachvolleyball": "Beach-volley",
      "billiards": "Billard",
      "bmx": "Bmx",
      "boules": "Pétanque",
      "bowls": "Boules",
      "boxing": "Boxe",
      "canadian_football": "Canadian football",
      "canoe": "Canoé",
      "chess": "Échec",
      "climbing": "Escalade",
      "climbing_adventure": "Climbing adventure",
      "cricket": "Cricket",
      "cricket_nets": "Cricket nets",
      "croquet": "Croquet",
      "curling": "Curling",
      "cycling": "Cyclisme",
      "disc_golf": "Disc golf",
      "diving": "Plongée",
      "dog_racing": "Dog racing",
      "equestrian": "Équitation",
      "fatsal": "Fatsal",
      "field_hockey": "Field hockey",
      "free_flying": "Free flying",
      "gaelic_games": "Gaelic games",
      "golf": "Golf",
      "gymnastics": "Gymnastique",
      "handball": "Handball",
      "hockey": "Hockey",
      "horse_racing": "Course de cheval",
      "horseshoes": "Horseshoes",
      "ice_hockey": "Hockey sur glace",
      "ice_stock": "Ice stock",
      "judo": "Judo",
      "karting": "Karting",
      "korfball": "Korfball",
      "long_jump": "Long jump",
      "model_aerodrome": "Model aerodrome",
      "motocross": "Motocross",
      "motor": "Motor",
      "multi": "Multi",
      "netball": "Netball",
      "orienteering": "Orienteering",
      "paddle_tennis": "Paddle tennis",
      "paintball": "Paintball",
      "paragliding": "Paragliding",
      "pelota": "Pelote",
      "racquet": "Racquet",
      "rc_car": "Rc car",
      "rowing": "Aviron",
      "rugby": "Rugby",
      "rugby_league": "Tugby league",
      "rugby_union": "Tugby union",
      "running": "Running",
      "sailing": "Sailing",
      "scuba_diving": "Scuba diving",
      "shooting": "Shooting",
      "shooting_range": "Shooting range",
      "skateboard": "Skateboard",
      "skating": "Skating",
      "skiing": "Ski",
      "soccer": "Football",
      "surfing": "Surf",
      "swimming": "Natation",
      "table_soccer": "Baby-foot",
      "table_tennis": "Tennis de table",
      "team_handball": "Team handball",
      "tennis": "Tennis",
      "toboggan": "Toboggan",
      "volleyball": "Volley-ball",
      "water_ski": "Ski nautique",
      "yoga": "Yoga"
    },
    "tourism": {
      "alpine_hut": "Cabane alpine",
      "aquarium": "Aquarium",
      "artwork": "Œuvre d'art",
      "attraction": "Attraction",
      "bed_and_breakfast": "Bed and breakfast",
      "camp_site": "Camping",
      "caravan_site": "Emplacement de caravane",
      "chalet": "Chalet",
      "gallery": "Galerie",
      "guest_house": "Chambre d’hôte",
      "hostel": "Auberge de jeunesse",
      "hotel": "Hôtel",
      "information": "Information",
      "motel": "Motel",
      "museum": "Musée",
      "picnic_site": "Site de pique-nique",
      "theme_park": "Theme park",
      "viewpoint": "Point de vue",
      "zoo": "Zoo"
    }
  },
  "search": "Rechercher",
  "sidebar": {
    "about": {
      "created_by": "Créé par François de Metz",
      "title": "A propos"
    },
    "api": {
      "embed": {
        "cta": "Lire la doc",
        "subtitle": "Afficher le lecteur interactif, prévisualiser des fichiers et plus avec l'API de télécommande.",
        "title": "Intégrer indoor="
      },
      "indoorequal": {
        "cta": "S'enregistrer",
        "subtitle": "Pour commencer, créer votre compte gratuit sur indoorequal.com.",
        "title": "Afficher les tuiles vectorielles d'indoor="
      },
      "schema": {
        "cta": "Lire",
        "subtitle": "Découvrir le schéma des tuiles vectorielles pour les intégrer dans votre application",
        "title": "Lire le schéma"
      },
      "subtitle": "Intégrer indoor= à votre app",
      "title": "Développeurs"
    },
    "collapse": "Replier",
    "description": "indoor= affiche les données intérieures d'{0} et prévisualise les fichiers GeoJSON, OSM et IMDF.",
    "explore": {
      "subtitle": "Lieux cartographiés en intérieur",
      "title": "Explorer"
    },
    "last_update": "Dernière mise à jour {0}. {1}.",
    "status": "Status",
    "learn": {
      "subtitle": "Les espaces intérieurs dans OpenStreetMap",
      "title": "Apprendre"
    },
    "news": {
      "subtitle": "Quoi de neuf sur indoor=",
      "title": "Nouveautés"
    },
    "preview": {
      "title": "Prévisualisation du rendu",
      "subtitle": "Validation avant envoi"
    },
    "taginfo": {
      "title": "Indoor= taginfo",
      "subtitle": "Une instance dédiée aux données intérieures"
    },
    "osm": "OpenStreetMap"
  },
  "preview": {
    "close": "Quitter la prévisualisation",
    "description": "Vérifier le rendu de votre cartographie intérieure. Sélectionner ou glisser déposer un fichier GeoJSON ou osm qui suit les recommandations de Simple Indoor Tagging.",
    "download": "Télécharger le fichier de prévisualisation",
    "error": "Une erreur est apparue lors de la prévisualisation: {msg}.",
    "error_bad_file": "Impossible d'ouvrir le fichier",
    "error_no_level": "Aucune donnée intérieure détectée",
    "file": "Fichier GeoJSON, osm ou IMDF (zip)",
    "how": {
      "use_josm_plugin": "La façon la plus rapide pour utiliser la prévisualisation est d'utiliser le plugin JOSM.",
      "content1": "Ouvrir JOSM et modifier une zone intérieur",
      "content2": "Clicker sur \"Fichier\" -> \"Enregistrer sous\" et enregistrer le fichier en tant que GeoJSON ou osm",
      "content3": "Sélectionner le fichier obtenu dans le formulaire en dessous",
      "title": "Comment faire"
    },
    "imdf": "La prévisualisation fonctionne également avec les fichiers IMDF.",
    "no_data_uploaded": "Aucune donnée n'est envoyée a distance. Tout se passe sur votre ordinateur.",
    "title": "Prévisualisation du rendu",
    "url": {
      "no": "Non",
      "text": "Voulez charger un fichier de prévisualisation depuis {0} ?",
      "title": "Chargement d'une prévisualisation externe",
      "yes": "Oui"
    }
  },
  "toolbar": {
    "edit": "Modifier OpenStreetMap",
    "menu": "Menu",
    "view": "Voir la carte",
    "zoom_to_edit": "Zoomer pour pouvoir éditer"
  },
  "wheelchair": {
    "limited": "Accessibilité limité",
    "no": "Non accessible",
    "yes": "Accessible aux fauteuils"
  },
  "zoom": "Zoomer pour voir les données intérieures"
}
